
import { Component, Vue } from 'vue-property-decorator';
import WebsiteMain from '~/components/website/WebsiteMain.vue';
import CookieHeader from '~/components/website/header/CookieHeader.vue';

@Component({
	name: 'PlainCompanyLayout',
	components: {
		WebsiteMain,
		CookieHeader,
		WebsiteFooter: () => import('~/components/website/footer/WebsiteFooter.vue')
	},
	head: {
		title:
			'Mit hokify einfach und schnell Kandidaten finden über: ► Social Media Recruiting ► Mobile Recruiting ► hy!Active'
	}
})
export default class PlainCompanyLayout extends Vue {}
